<router-outlet></router-outlet>
<!--utilisé par modale service dialog box-->
<div kendoDialogContainer></div>